import React from 'react';

export default function Button({
  children,
  variant = 'primary',
  disabled = false,
  loading = false,
  className = '',
  ...props
}) {
  const base = 'inline-flex items-center justify-center font-semibold rounded-[10px] transition duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed focus:ring-2 focus:ring-offset-2 focus:ring-[#0ea5e9]/40';
  const variants = {
    primary: 'px-5 py-2.5 bg-[#0ea5e9] hover:bg-[#0284c7] text-white shadow-sm',
    secondary: 'px-5 py-2.5 bg-transparent border border-[#e2e8f0] text-[#0f172a] hover:bg-slate-100 dark:border-slate-600 dark:text-slate-200 dark:hover:bg-slate-700/50',
    ghost: 'px-5 py-2.5 hover:bg-slate-100 text-[#475569] dark:hover:bg-slate-700/50 dark:text-slate-300',
  };
  return (
    <button
      className={`${base} ${variants[variant]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="animate-spin h-4 w-4 border-2 border-current border-t-transparent rounded-full" />
      ) : (
        children
      )}
    </button>
  );
}
